<template>
  <td class="row-column" v-if="collapsibleSelectionEnabled"></td>
  <td :colspan="columnsContentCount" class="row-column">
    <template v-for="value in htmlValues">
      <span v-html="value.html"></span>
    </template>
  </td>
  <td v-if="collapsibleButtonShow" class="row-column">
    <div class="wrapper">
      <div class="column-collapsible">
        <a type="button" class="btn float-right" @click.prevent="collapsibleButtonOnClicked(props.id, props.index)"
          :title="collapsibleButtonStateIsOpen ? collapsibleButtonStateIsOpenMessage : collapsibleButtonStateIsClosedMessage">
          <i v-if="collapsibleButtonStateIsOpen" class="eii--fa6-solid--square-minus"></i>
          <i v-if="!collapsibleButtonStateIsOpen" class="eii--fa6-solid--square-plus"></i>
        </a>
      </div>
    </div>
  </td>
</template>

<script setup lang="ts">
import { ref, inject, watch } from 'vue'

import { DefinitionListContentColumn, DataListRowEntityEntry, DefinitionListContentConfiguration, DataListLookup, DefinitionListContentConfigurationSelection } from '@/components/types'

import { useCollapsible } from '@/components/ListRowColumnBody/collapsible'

import { useDataStore } from '@/stores/data'

interface Props {
  columns?: DefinitionListContentColumn[]
  config: DefinitionListContentConfiguration
  lookups: DataListLookup[]
  entry: DataListRowEntityEntry
  selection: DefinitionListContentConfigurationSelection
  id: string | number
  index: string | number
  columncount: number,
  entity: string
}

const props = withDefaults(defineProps<Props>(), {
  columns: undefined,
  config: undefined,
  lookups: undefined,
  entry: undefined,
  selection: undefined,
  id: undefined,
  index: undefined,
  columncount: undefined,
  entity: undefined
})

const listMetaId: string = inject('listMetaId', '')

const bucketId = listMetaId + '/' + props.entity + '/' + props.id

const { link } = useDataStore()

const bucket = link(bucketId)

const htmlValues = ref(props.entry.values)

watch(
  props.entry.values,
  (n) => {
    htmlValues.value = n
  }
)

watch(
  bucket,
  (n: any) => {
    if ('data' in n && bucketId in n.data && 'values' in n.data[bucketId]) {
      htmlValues.value = n.data[bucketId].values
    }
  },
  { deep: true }
)

const emit = defineEmits(['hcl-list-row-column-body-collapsible-clicked'])

const collapsibleButtonOnClicked = (id: string | number, index: string | number) => {
  emit('hcl-list-row-column-body-collapsible-clicked', { id: id, index: index })
}

const {
  collapsibleButtonShow,
  collapsibleButtonStateIsOpen,
  collapsibleButtonStateIsOpenMessage,
  collapsibleButtonStateIsClosedMessage,
  collapsibleSelectionEnabled,
  columnsContentCount
} = useCollapsible(props)
</script>

<style scoped lang="scss">
.hcl-list-header-column-body {
  color: var(--theme-color-interaction, '#0c3e94');
  vertical-align: top;
  border-top: none;
  border-bottom: none;

  &.column-header-collapsible {
    width: 2rem;
  }
}
</style>
